const adminReducer = (admin = [], action) => {
    switch (action.type) {

        case "GET_USERS":
            return action.payload

        case "UPDATE_USER":
            return admin.map((item) =>
                item._id === action.payload._id ? action.payload : item
            )

        case "DELETE_USER":
            return admin.filter((item) => item._id !== action.payload)

        default:
            return admin
    }
}

export default adminReducer;